jQuery(document).ready(function ($) {
//	$(".category-slider").css("visibility","visible");

	//$('#banner-slider .owl-stage-outer img, #banner-slider .owl-stage-outer video source').each(function () {
	$('#banner-slider .owl-stage-outer img').each(function () {
		$(this).attr('src',$(this).data('src'));
    });

	$("#artisan_overlay").hide();
	$(".trending_overlay").hide();
	$("#trending_overlay_mob").hide();
	$("#collection_overlay").hide();
	$(".owl-carousel .banner-content").show();
	$("#company-project-type li").each(function () {
		$(this).click(function () {
			$(this).addClass("selected");
			$(this).siblings().removeClass("selected");
		});
	}); 

	$(".tb2Opn").click(function () {
		$(".tbr2Cls").fadeIn();
		$(".topbr2").slideDown(); 	
		// $(".advance-option").slideDown();

		$(".mskBr").fadeIn();
	});

	$(".tbr2Cls").click(function () {
		$(this).fadeOut();
		$(".topbr2").slideUp();
		//$(".mskBr").fadeOut();
	});

	$("a.dropdown-toggle").click(function(){
		if($(this).html()=="Collection"){
			document.location = $(this).attr('href');
		}
	});
	$(window).on('scroll', function(){
		if($(document).scrollTop() > 200){
			$("#yt-totop").show();
		}else{
			$("#yt-totop").hide();
		}
	}); 
	$("#yt-totop").click(function(){
		$("html, body").animate({ scrollTop: 0 }, "slow");
	});

    var width = jQuery(window).width()
	if(width > 1144){
	    setTimeout(function(){
        	var controller = new ScrollMagic.Controller();
			height = jQuery("#scroll-div-section1 img").height() - jQuery("#scroll-inner1").height()-100;
            var scene = new ScrollMagic.Scene({triggerElement: "#scroll-div-section1", duration: height,triggerHook:0})
                                                                .setPin("#scroll-inner1")
                                                                .addTo(controller);
			height = jQuery("#scroll-div-section2 img").height() - jQuery("#scroll-inner2").height()-100;
            var scene = new ScrollMagic.Scene({triggerElement: "#scroll-inner2", duration: height,triggerHook:0})
                                                                .setPin("#scroll-inner2")
                                                                .addTo(controller);
	      }, 2000);
	}

	jQuery(".masonry .item").click(function(){
	    document.location = $(this).find("a").attr('href');;
	});

	$('.owl-dot').attr('aria-label', 'slide-dot');

});





/*jQuery(window).scroll(function ($) {

	var sticky = jQuery('.pdp-top-bar');
	//var imgsticky=jQuery('.media');
	var scroll = jQuery(window).scrollTop();
	if (scroll >= 320) {
		sticky.addClass('stickytop');
		// $('.catalog-product-view.page-layout-1column .product.media').addClass('stt1');
		// $('.product-info-content').addClass('stt2');
	} else {
		sticky.removeClass('stickytop');
		// $('.catalog-product-view.page-layout-1column .product.media').removeClass('stt1');
		// $('.product-info-content').removeClass('stt2');
	}
});
*/




